 
<template>
  <div>
    <header class="headerCom">
      <el-form :inline="true" size="small">
        <el-form-item>
          <div class="head-return" @click="goReturn">返回</div>
          <span>消息模板</span>
        </el-form-item>
        <el-form-item class="float-right">
          <el-button type="primary" @click="addMessageTem">添加模板</el-button>
        </el-form-item>
      </el-form>
    </header>
    <div class="new_container" v-loading='loading' id='setHeightDom' :style="{height:height}">
      <BaseTable class="set-row-height" :data="tableData"
        :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}" tooltip-effect="dark"
        :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="listQuery.current"
        :limit.sync="listQuery.size" @pagination="getList">
      </BaseTable>
    </div>
    <el-dialog title="消息模板" :visible.sync="dialogVisible" width="530px" class="group-dialog"
      :close-on-click-modal='false'>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="100px" class="demo-ruleForm">
        <el-form-item label="消息名称：" prop="pushName">
          <el-input v-if="!editeStatus" v-model="ruleForm.pushName" show-word-limit maxlength="10"
            placeholder="请输入消息名称"></el-input>
          <span v-else>{{ruleForm.pushName}}</span>
        </el-form-item>
        <el-form-item label="提示说明：" prop="describe">
          <el-input type="textarea" v-if="!editeStatus" class="set-opacity" show-word-limit v-model="ruleForm.describe"
            maxlength="20" placeholder="请输入提示说明">
          </el-input>
          <span v-else>{{ruleForm.describe}}</span>
        </el-form-item>
        <el-form-item label="IM文案：" prop="msgBody">
          <el-input type="textarea" v-if="!editeStatus" rows="5" class="set-opacity" show-word-limit
            v-model="ruleForm.msgBody" maxlength="500" placeholder="请输入IM文案">
          </el-input>
          <span v-else>{{ruleForm.msgBody}}</span>
        </el-form-item>

        <el-form-item label="其他类型：" v-if="!editeStatus" prop="tip">
          <el-popover placement="top-start" width="342" trigger="click">
            <div class="tip-box">
              <div class="tip-item" v-for="(item, index) in tipItems" :key="index" @click="otherTypes(item.name)">
                <div class="tip-item-icon">
                  <img class="tip-img" :src="item.ImgPath" alt="">
                </div>
                <div class="tip-item-text">{{ item.name }}</div>
                <BaseUploadFile class="upInput" :isCompress='true' :fileType="['png', 'jpg', 'jpeg']"  v-if="item.id==9" :fileSize="10" :isShowTip="false"
                  :cropWidth="250" :cropHeight="200" message="" :multiple='true' :size="60"
                  action="/api/dsicm-contact-platform/feign/file/upload" :responseFn="handleSharingPicUrlResponse"
                  :data="{ path: 'dsicm-doctor', type: 'image' }" v-model="upPicUrl">
                </BaseUploadFile>
              </div>
            </div>
            <el-button plain class="addBtn" v-if="!editeStatus" slot="reference">+ 添加</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item :label="editeStatus?'其他类型：':''" prop="tip">
          <div id="list-tip-box">
            <div class="list-item" v-for="(item, index) in ruleForm.additionalContentList" :key="index">
              <div class="tag">
                <span>{{ item.typeName }}</span>
              </div> 
              <el-image class="flex preview-img" v-if="item.typeId == 9"  :src="imgUrl+item.body.content"
                :preview-src-list="[imgUrl+item.body.content]">
              </el-image>
              <div v-else class="flex">{{ item.body.content ? item.body.content : item.body.title }}</div>
              <img v-if="!editeStatus" @click="delContent(index)" src="@/assets/images/tooltipsIcon/listIcon.png"
                alt="">
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="editeStatus">
        <el-button size="small" type="primary" @click="editeStatus = false">编辑</el-button>
      </div>
      <div slot="footer" v-else>
        <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </div>

    </el-dialog>
    <!-- 在线教程弹窗 -->
    <OnlineCourse ref="courseDialog" @receiveParams="receiveParams" />
    <!-- 宣传患教弹窗 -->
    <Education ref="educationDialog" @receiveParams="receiveParams" />
    <!-- 选择问卷弹窗 -->
    <AddQuestionDialog v-if="questionCom.visible" :showAddQuestion.sync="questionCom.visible" :title="questionCom.title"
      @receiveParams="receiveParams" :showCompanyBtn="true" />
    <!-- 推荐服务 -->
    <ServiceRecommon v-if="serviceRecommon.visible" :showAddQuestion.sync="serviceRecommon.visible"
      :title="serviceRecommon.title" @receiveParams="receiveParams" :planPage="true" />
    <!-- 病历夹 -->
    <RecordFolder ref="folderDialog" @receiveParams="receiveParams" />
  </div>
</template> 
<script>
import {
  templateList,
  cretaedTemplate,
  templateDetail
} from "@/api/Patientmanagement.js";
import OnlineCourse from "@/views/pushManagement/dialogComponent/onlineCourse.vue";
import Education from "@/views/pushManagement/dialogComponent/education.vue";
import AddQuestionDialog from "@/views/ToolMaintenance/component/addQuestionDialog.vue";
import ServiceRecommon from "@/views/treatment/components/serviceRecommon/index";
import RecordFolder from "@/views/pushManagement/dialogComponent/recordFolder.vue";
export default {
  components: {
    OnlineCourse,
    Education,
    AddQuestionDialog,
    ServiceRecommon,
    RecordFolder
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_OSS_URL,
      upPicUrl: "",
      dialogVisible: false,
      editeStatus: false,
      loading: false,
      total: 100,
      listQuery: {
        current: 1,
        size: 10
      },
      height: 500,
      tableData: [],
      ruleForm: {
        id: "",
        pushName: "",
        describe: "",
        msgBody: "",
        additionalContentList: []
      },
      // 推荐服务
      serviceRecommon: {
        visible: false,
        title: "推荐服务",
        param: {}
      },
      questionCom: {
        visible: false,
        params: {},
        title: "选择问卷"
      },
      tipItems: [
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book.png"),
          name: "在线教程",
          id: 2
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book1.png"),
          name: "宣传患教",
          id: 3
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book2.png"),
          name: "问卷选择",
          id: 4
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book4.png"),
          name: "推荐服务",
          id: 6
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book5.png"),
          name: "病历夹",
          id: 7
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book3.png"),
          name: "症状卡片",
          id: 8
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book6.png"),
          name: "发送图片",
          id: 9
        }
      ],
      rules: {
        pushName: [
          { required: true, message: "请输入消息名称", trigger: "blur" }
        ],
        describe: [
          { required: true, message: "请输入提示说明", trigger: "blur" }
        ],
        msgBody: [{ required: true, message: "请输入IM文案", trigger: "blur" }]
      },
      tableConfig: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "模板ID",
          align: "center",
          prop: "templateId",
          size: "mini"
        },
        {
          label: "模板名称",
          align: "center",
          prop: "pushName",
          size: "mini"
        },
        {
          label: "提示说明",
          align: "center",
          prop: "describe",
          size: "mini"
        },
        {
          label: "IM文案",
          align: "center",
          prop: "msgBody"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.lookDetails(scope.row);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.height = this.handleHeight() - 60 + "px";
    this.getList();
  },
  methods: {
    lookDetails(row) {
      this.editeStatus = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
      this.getDetails(row.id);
    },
    async getDetails(id) {
      let res = await templateDetail(id);
      if (res.code == 0) {
        let end = res.data;
        this.ruleForm.id = end.id;
        this.ruleForm.pushName = end.pushName;
        this.ruleForm.describe = end.describe;
        this.ruleForm.msgBody = end.msgBody;
        this.ruleForm.additionalContentList = end.additionalContentList;
      }
    },
    //接收弹窗参数
    receiveParams(params) {
      switch (params.emitType) {
        case "在线教程":
          this.ruleForm.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.courseName
            },
            typeId: 2,
            typeName: "在线教程"
          });
          break;
        case "宣传患教":
          this.ruleForm.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.title
            },
            typeId: 3,
            typeName: "宣传患教"
          });
          break;
        case "问卷选择":
          this.ruleForm.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.title
            },
            typeId: 4,
            typeName: "问卷选择"
          });
          break;
        case "推荐服务":
          this.ruleForm.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.name
            },
            typeId: 6,
            typeName: "推荐服务"
          });
          break;
        case "症状卡片":
          this.ruleForm.additionalContentList.push({
            body: {
              content: null,
              id: null,
              title: null
            },
            typeId: 8,
            typeName: "症状卡片"
          });
          break;
        case "病历夹":
          this.ruleForm.additionalContentList.push({
            body: {
              content: params.content,
              id: null,
              title: params.title
            },
            typeId: 7,
            typeName: "病历夹"
          });
          break;
        case "发送图片":
          this.ruleForm.additionalContentList.push({
            body: {
              content: params.content,
              id: null,
              title: params.title
            },
            typeId: 9,
            typeName: "发送图片"
          });
          break;
        default:
          break;
      }
    },
    //选择其他类型
    otherTypes(e) {
      switch (e) {
        case "在线教程":
          this.$refs.courseDialog.$emit("openDialog");
          break;
        case "宣传患教":
          this.$refs.educationDialog.$emit("openDialog");
          break;
        case "问卷选择":
          this.questionCom.visible = true;
          break;
        case "推荐服务":
          this.serviceRecommon.visible = true;
          break;
        case "症状卡片":
          this.receiveParams({
            emitType: "症状卡片"
          });
          break;
        case "病历夹":
          this.$refs.folderDialog.$emit("openDialog");
          break;
        default:
          break;
      }
    },
    //删除其他类型数组内容
    delContent(index) {
      this.ruleForm.additionalContentList.splice(index, 1);
    },
    goReturn() {
      this.$router.go(-1);
    },
    handleSharingPicUrlResponse(end) {
      let index = end.data.indexOf("/");
      this.receiveParams({
        emitType: "发送图片",
        content: end.data,
        title: end.data.slice(index + 1)
      });
    },
    onResetClick(val) {
      this.listQuery = this.$options.data().listQuery;
    },
    onSearchClick() {
      this.listQuery.current = 1;
      this.getList();
    },
    addMessageTem() {
      this.dialogVisible = true;
      this.ruleForm = this.$options.data().ruleForm;
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
    },
    handleSizeChange(val) {
      this.loading = true;
      this.listQuery.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.listQuery.current = val;
      this.getList();
    },
    //获取列表数据接口
    async getList() {
      let params = this.listQuery;
      let res = await templateList(params);
      this.loading = false;
      this.tableData = res.data && res.data.records;
      this.total = res.data.total;
    },
    // 创建模板

    async cretaedTemplate() {
      let params = this.ruleForm;
      await cretaedTemplate(params);
      this.dialogVisible = false;
      this.$message.success("创建成功");
      this.listQuery.current = 1;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.cretaedTemplate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script> 
<style lang="less" scoped>
.tip-box {
  display: flex;
  flex-wrap: wrap;

  .tip-item {
    width: 25%;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    .upInput {
      position: absolute;
      top: 0;
      left: 0;
      border: solid;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .tip-item-icon {
      cursor: pointer;
      width: 26px;
      height: 26px;
      background: #363f4d;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-bottom: 5px;

      .tip-img {
        width: 17px;
        height: 15px;
      }
    }

    .tip-item-text {
      cursor: pointer;
      font-size: 12px;
    }
  }
}
.addBtn {
  border: 1px dashed #dcdfe6;
  width: 100%;
}
#list-tip-box {
  width: 100%;
  max-height: 200px;
  overflow: auto;
  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/.preview-img img{
      width: 30px;
      height: 30px;
    }
    /deep/.el-image-viewer__canvas img{
      width: auto;
      height: auto;
    }
    :nth-last-child {
      margin-bottom: 0;
    }

    .tag{
      background: #eff6ff;
      border-radius: 4px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 12px;
        color: #1a7bfc;
        margin: 6px;
      }
    }

    .flex{
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      margin: 0px 10px 0px 10px;
    }

    :nth-child(3) {
      width: 24px;
      height: 24px;
    }
  }
}
.head-return {
  display: inline-block;
  width: 50px;
  border-radius: 12px;
  border: 1px solid #cccccc;
  text-align: center;
  line-height: 24px;
  color: #666666;
  margin: 18px 28px 0 0;
  cursor: pointer;
}
.new_container {
  margin: 16px 16px 0;
  padding: 24px;
  background: #fff;
  overflow: auto;
}
.float-right {
  float: right;
  margin-top: 18px;
}
/deep/.group-dialog .el-dialog__body {
  padding-bottom: 0;
}
</style>
